/**
 * Extract field constraints from a JSON Schema.
 * These constraints can be used for UI hints like showing maxLength counters,
 * required field indicators, etc.
 *
 * @param schema - The field's schema
 * @param parentSchema - Optional parent schema to check required array
 * @param fieldName - Optional field name to check in parent's required array
 */
export function getFieldConstraints(schema, parentSchema, fieldName) {
    const constraints = {};
    // Required comes from parent schema's required array
    if (parentSchema && fieldName) {
        constraints.required = parentSchema.required?.includes(fieldName) ?? false;
    }
    // String constraints
    if (schema.minLength !== undefined)
        constraints.minLength = schema.minLength;
    if (schema.maxLength !== undefined)
        constraints.maxLength = schema.maxLength;
    if (schema.pattern !== undefined)
        constraints.pattern = schema.pattern;
    if (schema.format !== undefined)
        constraints.format = schema.format;
    // Number constraints
    if (schema.minimum !== undefined)
        constraints.minimum = schema.minimum;
    if (schema.maximum !== undefined)
        constraints.maximum = schema.maximum;
    if (schema.exclusiveMinimum !== undefined) {
        constraints.exclusiveMinimum = typeof schema.exclusiveMinimum === 'number' ? schema.exclusiveMinimum : undefined;
    }
    if (schema.exclusiveMaximum !== undefined) {
        constraints.exclusiveMaximum = typeof schema.exclusiveMaximum === 'number' ? schema.exclusiveMaximum : undefined;
    }
    // Enum
    if (schema.enum !== undefined) {
        constraints.enum = schema.enum;
    }
    // Array constraints
    if (schema.minItems !== undefined)
        constraints.minItems = schema.minItems;
    if (schema.maxItems !== undefined)
        constraints.maxItems = schema.maxItems;
    return constraints;
}
